import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../shared';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Puser, SWF, User } from '../../shared/models';
import { environment } from '../../shared/config/app-config';
import * as _ from 'lodash'
@Component({
  templateUrl: 'carefamily.component.html',
  styleUrls: ['./style.component.css']
})

export class CarefamilyComponent implements OnInit {
  carepathfamilyData: any;
  partnerdetail: any;
  carepartnerlist: any;
  public data: Object;
  modalRef: BsModalRef;
  PUser: Puser;
  public apiurl: any = environment.api_url;
  resp: any;
  SWF: SWF;
  CurrentUser: User;
  care1: any;
  carepathfamily: any;
  public imageURL: string = environment.cloudeImageURL;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private userService: UserService
  ) {
  }
  openModal(template: TemplateRef<any>, care: any) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.care1 = care;
  }
  ngOnInit() {
    var cid;
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
        // ////console.log(this.CurrentUser)
        if (this.CurrentUser.item) {
          if (this.CurrentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;

          if (window.localStorage['ccdetails']) {
            let ccdetails = JSON.parse(atob(window.localStorage['ccdetails']))
            cid = ccdetails.cnuseraccid
          } else {
            cid = this.CurrentUser.item.userAccountId
          }
        }
      }
    )
    if (this.route.snapshot.url[0].path != 'assessment') {
      this.CurrentUser.operationStatus = ''
    }
    this.userService.PUser.subscribe(
      (puserData) => {
        this.resp = puserData;
        this.PUser = puserData;
        this.userService
          .getpcarefamily(window.localStorage['Puser'], cid)
          .subscribe(
            data => {
              this.carepathfamilyData = data;
              this.carepathfamily = this.carepathfamilyData.HospitalCareNavigatorDetails.concat(this.carepathfamilyData.CareNavigatorDetails);
              this.carepathfamily = _.orderBy(this.carepathfamily, ['sequenceNo'], 
              ['asc']);
            }
          );

        this.userService
          .getcarepartner(cid, this.resp.patientId)
          .subscribe(
            data => {
              this.carepartnerlist = data;
              //////console.log(this.carepartnerlist);        
            }
          );
      }
    )
  }
  addpatlink() {
    this.router.navigate(['patient/addcare'])
  }
  updatedetils(idspass) {
    // //////console.log(idspass);
    if (!this.CurrentUser.item.onBehalf){
      let careId = {
        'name':idspass
      }
      window.localStorage['careId'] = btoa(JSON.stringify(careId));
      this.router.navigate([`patient/patsy`])
    }

  }
}






